import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Terms from "./pages/Terms";
import Homepage from "./pages/Homepage";
import Test from "./pages/Test";
import Login from "./pages/Login";
import SignUp from "./pages/Signup";
import TcLogin from "././components/tcs/TcLogin";
import TcSignup from "./components/tcs/TcSignup";
import TcDashboard from "./components/tcs/TcDashboard";
import DriverLogin from "./components/drivers/DriverLogin";
import DriverSignup from "./components/drivers/DriverSignup";
import DriverDashboard from "./components/drivers/DriverDashboard";
import PoliceStation from "./pages/PoliceStation";
import Laws from "./pages/Laws";
import PrivateComponent from "./pages/PrivateComponent";
import AddLaw from "./components/tcs/AddLaw";
import UpdateLaw from "./components/tcs/UpdateLaw";
import AddCase from "./components/tcs/AddCase";
import Case from "./components/tcs/Case";
import UpdateCase from "./components/tcs/UpdateCase";
import LicensePlateCapture from "./components/tcs/LicensePlateCapture";
import ImageClassify from "./components/tcs/ImageClassify";
import CaseView from "./components/drivers/CaseView";
import UpdateReq from "./components/drivers/UpdateReq";
import PageNotFound from "./pages/PageNotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PrivateComponent/>}>
          {/* TC */}
          <Route path="/tc/dashboard" element={<TcDashboard />} />
          <Route path="/add/laws" element={<AddLaw />} />
          <Route path="/update/laws/:key" element={<UpdateLaw />} />
          <Route path="/cases" element={<Case />} />
          <Route path="/add/cases" element={<AddCase />} />
          <Route path="/update/cases/:key" element={<UpdateCase />} />
          <Route path="/license-detect" element={<LicensePlateCapture />} />
          <Route path="/images-classify" element={<ImageClassify />} />
          {/* Drivers */}
          <Route path="/driver/dashboard" element={<DriverDashboard />} />
          <Route path="/case/view" element={<CaseView />} />
          <Route path="/request/update/:key" element={<UpdateReq />} />
        </Route>

        <Route path="/policestation" element={<PoliceStation />} />
        <Route path="/laws" element={<Laws />} />
        <Route path="/" element={<Homepage />} />

        {/* Testing */}
        <Route path="/developer-team" element={<Test />} />

        <Route path="/login" element={<Login />} />
        <Route path="/tc/login" element={<TcLogin />} />
        <Route path="/driver/login" element={<DriverLogin />} />

        <Route path="/signup" element={<SignUp />} />
        <Route path="/tc/signup" element={<TcSignup />} />
        <Route path="/driver/signup" element={<DriverSignup />} />

        <Route path="/terms" element={<Terms />} />

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App; 
